/**
 * ListManager component
 * 
 * @TODO: Adapt current mapping object for Search into a streamlined thing here (eg, icons for types and so forth)
 * @TODO: Install router in bundler config (... and follow-on tasks /lists/<id> param passing)
 * @TODO: Further componentization (eg, ItemView shared by both top-level routed Views)
 * 
 * A basic SPA with routing that serves basic CRUD operations on lists:
 * - /lists/ - AllListsView
 * - /lists/login - LoginView
 * - /lists/<id> - ListItemsView
 * - /lists/export - ListExportView (or may be a dialog)
 * - /lists/<id>/export/<uuid-id> - ExternalItemsView
 * 
 * Other components:
 * - ModalUserView - modal used throughout for add / delete / share select screens
 * - ExportView - used to export this list
 * - ShareView - used to fill out share details 
 * 
 **/ 
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';

import { routeTree } from './routeTree.gen'

document.addEventListener('DOMContentLoaded',() => {
  const el = document.getElementById('listManagerRoot');
  const dataset = el.dataset;

  const endpointPath = dataset.indexName ? `${dataset.indexName}/_search`: 'entity/_search'
  const endpointUrl = new URL(endpointPath, dataset.endpoint);
  const endpoint = endpointUrl.href

  const router = createRouter({ context: { endpoint }, basepath: '/list/', routeTree, }) 

  ReactDOM.createRoot(el).render( <RouterProvider router={router} /> )
})